import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  listItem: {
    width: '100%',
    paddingLeft: theme.spacing(2.5),
    color: theme.palette.grey[400],
    '&.Mui-selected': {
      color: theme.palette.primary.main,
      background: theme.palette.grey[900],
    },
  },
  listIcon: {
    paddingLeft: theme.spacing(0.5),
    minWidth: 'auto',
    width: 16,
    height: 16,
  },
  loadingContent: {
    paddingLeft: theme.spacing(2.5),
  },
}));

export default useStyles;
